import type { PropsWithChildren, SelectHTMLAttributes } from "react";
import clsx from "clsx";
import {
  fieldControlClassName,
  singleLineControlClassName,
} from "./form-control-styles";

type Props = PropsWithChildren<SelectHTMLAttributes<HTMLSelectElement>>;

export const Select = ({ className, children, ...props }: Props) => {
  return (
    <select
      className={clsx(
        fieldControlClassName,
        singleLineControlClassName,
        "pr-10",
        className,
      )}
      {...props}
    >
      {children}
    </select>
  );
};

export default Select;
